import { useParams } from "@tanstack/react-router";
import { useModuleEnabled } from "../../redux/selectors/modules";
import AdvertisingDashboard from "../AdvertisingDashboard";
import AdvertisingDashboardV2 from "../AdvertisingDashboardV2";
import AdvertisingOverview from "../AdvertisingOverview";

// Canonical advertising dashboard route: pick the body in place from the URL + ADS_V1
// module so toggling versions (or deep-linking a category) never needs a redirect.
export function AdvertisingDashboardRoute() {
  const hasAdsV1Module = useModuleEnabled("ADS_V1");
  const { id } = useParams({ strict: false });
  if (!id) return <AdvertisingDashboard />;
  if (!hasAdsV1Module) return <AdvertisingDashboardV2 />;
  return <AdvertisingOverview />;
}
